import React, { FC } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import MButton from '../../inputs/yup/materialui/mButton';

interface ConfirmationModalProps {
    onHide: () => void;
    onConfirm: () => void;
    show: boolean;
    title?: string;
    message: string;
    size?: "sm" | "lg" | "xl" | undefined;
}

const ConfirmationModal: FC<ConfirmationModalProps> = ({ onHide, onConfirm, show, title, message, size }) => {

    function handleConfirm() {
        onHide();
        onConfirm();
    }

    function handleCancel() {
        onHide();
    }

    const getSize = () => {
        switch (size) {
            case "sm":
                return "xs";
            case "lg":
                return "md";
            case "xl":
                return "lg";
            default:
                return "sm";
        }
    };

    return (
        <Dialog
            open={show}
            onClose={onHide}
            maxWidth={getSize()}
            fullWidth
        >
            {title &&
                <DialogTitle
                >
                    {title}
                </DialogTitle>}
            <DialogContent>
                {message}
            </DialogContent>
            <DialogActions>
                <MButton variant='contained' color="primary" onClick={handleConfirm}>
                    Aceptar
                </MButton>
                <MButton variant='contained' color="inherit" onClick={handleCancel}>
                    Cancelar
                </MButton>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmationModal;
